/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'bi/content_apps/common/ui/list_columns/Icon',
	'bi/commons/utils/Utils',
	'jquery'
], function(Icon, Utils, $) {
	'use strict';

	class LegacyAppsIcon extends Icon {

		createObjectImg(oData) {
			const $iconDiv = $('<div/>');
			if (!this.icon || !oData.apps) {
				let icon = this.icon;
				if (icon) {
					$iconDiv.addClass('legacyLink');
				} else {
					icon = oData.icon;
				}
				Utils.setIcon($iconDiv, icon, oData.label);
				$iconDiv.attr('role','presentation');
			}
			return $iconDiv;
		}
	}

	return LegacyAppsIcon;
});